export default function RouteFallback() {
  return (
    <div className="route-fallback" role="status" aria-live="polite">
      <p>Loading page…</p>
    </div>
  );
}
